import React from "react";
import { Box } from "@mui/material";
import { CustomTooltip } from "./date-header-tooltip.style";
import { MyTimeDateHeaderTooltipTitle } from "my-time/components";

type MyTimeDateHeaderTooltipProps = {
  workTime: number;
  overtime: number;
  voluntaryOvertime: number;
  children: React.ReactElement;
  isOffRange: boolean;
  date: Date | string;
};

export const MyTimeDateHeaderTooltip = ({
  workTime,
  overtime,
  voluntaryOvertime,
  children,
  isOffRange,
  date,
}: MyTimeDateHeaderTooltipProps) => {
  if (isOffRange) {
    return <Box>{children}</Box>;
  }

  return (
    <CustomTooltip
      title={
        <MyTimeDateHeaderTooltipTitle
          workTime={workTime}
          overtime={overtime}
          voluntaryOvertime={voluntaryOvertime}
          date={date}
        />
      }
      placement="top"
      arrow
    >
      {children}
    </CustomTooltip>
  );
};

export default MyTimeDateHeaderTooltip;
